module.exports = __webpack_public_path__ + "static/media/self_view.bb691e51.svg";